import i from 'icepick'
import { keyBy, flatten } from 'lodash'
import analytics from 'features/Analytics/Analytics.utils'

const initialState = {
  numbersById: {},
  numbers: [],
  numbersLoading: false,
  numberLoading: {},
  numbersCreateLoading: false,
  numbersUpdateLoading: false,
  disconnectionFees: {
    /**
     * [serviceId]: {
     *   fee: number,
     *   loading: boolean,
     *   submitting: boolean,
     * }
     */
  },
  usagePlanFees: {
    /**
     * [serviceId]: {
     *   fee: number,
     *   date: string
     *   loading: boolean,
     *   submitting: boolean,
     * }
     */
  },
  suitableUsagePlans: {
    /**
     * [serviceId]: {
     *   all: [],
     *   loading: boolean,
     *   submitting: boolean,
     * }
     */
  },
  callUsage: {
    /**
     * all: {
     *   data,
     *   loading,
     *   numPages
     * }
     * [serviceId-page]: {
     *   data,
     *   loading,
     *   numPages
     * },
     *
     */
  },
  available: {
    /**
     * [meta.cacheKet]: {
     *   data: [],
     *   loading: boolean,
     * }
     */
  },
  numbersAnalytics: [],
  numbersAnalyticsLoading: false,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case 'NUMBERS/GET_DISCONNECTION_FEE_PENDING':
      return i.assocIn(state, ['disconnectionFees', action.meta.serviceId, 'loading'], true)
    case 'NUMBERS/GET_DISCONNECTION_FEE_REJECTED':
      return i.assocIn(state, ['disconnectionFees', action.meta.serviceId, 'loading'], false)
    case 'NUMBERS/GET_DISCONNECTION_FEE_FULFILLED':
      return i.assocIn(state, ['disconnectionFees', action.meta.serviceId], {
        submitting: false,
        loading: false,
        fee: action.payload.data.disconnectionFee,
      })

    case 'NUMBERS/GET_CHANGE_USAGE_PLAN_FEE_PENDING':
      return i.assocIn(state, ['usagePlanFees', action.meta.serviceId, 'loading'], true)
    case 'NUMBERS/GET_CHANGE_USAGE_PLAN_FEE_REJECTED':
      return i.assocIn(state, ['usagePlanFees', action.meta.serviceId, 'loading'], false)
    case 'NUMBERS/GET_CHANGE_USAGE_PLAN_FEE_FULFILLED':
      return i.assocIn(state, ['usagePlanFees', action.meta.serviceId], {
        submitting: false,
        loading: false,
        fee: action.payload.data.fee,
        date: action.payload.data.date,
      })

    case 'NUMBERS/GET_SUITABLE_USAGE_PLANS_PENDING':
      return i.assocIn(state, ['suitableUsagePlans', action.meta.serviceId, 'loading'], true)
    case 'NUMBERS/GET_SUITABLE_USAGE_PLANS_REJECTED':
      return i.assocIn(state, ['suitableUsagePlans', action.meta.serviceId, 'loading'], false)
    case 'NUMBERS/GET_SUITABLE_USAGE_PLANS_FULFILLED':
      return i.assocIn(state, ['suitableUsagePlans', action.meta.serviceId], {
        submitting: false,
        loading: false,
        all: action.payload.data,
      })

    case 'NUMBERS/DISCONNECT_SERVICE_PENDING':
      return i.assocIn(state, ['disconnectionFees', action.meta.serviceId, 'submitting'], true)
    case 'NUMBERS/DISCONNECT_SERVICE_REJECTED':
      return i.assocIn(state, ['disconnectionFees', action.meta.serviceId, 'submitting'], false)
    case 'NUMBERS/DISCONNECT_SERVICE_FULFILLED':
      analytics.track('Numbers - Disconnect', action.meta.serviceId)
      return i.assocIn(state, ['disconnectionFees', action.meta.serviceId, 'submitting'], false)

    case 'NUMBERS/LINK_TWILIO_TO_AAPT_FULFILLED':
      analytics.track('Numbers - Link Twilio To AAPT', action.meta.serviceId)
      return state

    case 'NUMBERS/GET_CALL_USAGE_PENDING':
      return i.assocIn(state, ['callUsage', action.meta.cacheKey, 'loading'], true)
    case 'NUMBERS/GET_CALL_USAGE_REJECTED':
      return i.assocIn(state, ['callUsage', action.meta.cacheKey, 'loading'], false)
    case 'NUMBERS/GET_CALL_USAGE_FULFILLED':
      return i
        .chain(state)
        .assocIn(
          ['callUsage', action.meta.cacheKey, 'data'],
          flatten(action.payload.map(item => item.data))
        )
        .assocIn(['callUsage', action.meta.cacheKey, 'loading'], false)
        .assocIn(
          ['callUsage', action.meta.cacheKey, 'numPages'],
          parseInt(action.payload[0].headers['x-total-count'] / 20, 10) + 1
        )
        .value()

    case 'NUMBERS/GET_ALL_CALL_USAGE_PENDING': {
      return i.assocIn(state, ['callUsage', action.meta.cacheKey, 'loading'], true)
    }
    case 'NUMBERS/GET_ALL_CALL_USAGE_REJECTED':
      return i.assocIn(state, ['callUsage', action.meta.cacheKey, 'loading'], false)
    case 'NUMBERS/GET_ALL_CALL_USAGE_FULFILLED':
      return i
        .chain(state)
        .assocIn(['callUsage', action.meta.cacheKey, 'data'], action.payload.data)
        .assocIn(['callUsage', action.meta.cacheKey, 'loading'], false)
        .assocIn(
          ['callUsage', action.meta.cacheKey, 'numPages'],
          parseInt(action.payload.headers['x-total-count'] / 20, 10) + 1
        )
        .value()

    case 'NUMBERS/GET_NUMBER_PENDING':
      return i.assocIn(state, ['numberLoading', action.meta.id], true)
    case 'NUMBERS/GET_NUMBER_REJECTED':
      return i.assocIn(state, ['numberLoading', action.meta.id], false)
    case 'NUMBERS/GET_NUMBER_FULFILLED':
      return i
        .chain(state)
        .assocIn(['numberLoading', action.meta.id], false)
        .assocIn(['numbersById', action.meta.id], action.payload.data)
        .value()

    case 'NUMBERS/GET_NUMBERS_PENDING':
      return i.assocIn(state, ['numbersLoading'], true)
    case 'NUMBERS/GET_NUMBERS_REJECTED':
      return i.assocIn(state, ['numbersLoading'], false)
    case 'NUMBERS/GET_NUMBERS_FULFILLED':
      return i
        .chain(state)
        .assocIn(['numbersLoading'], false)
        .assocIn(
          ['numbers'],
          action.payload.data.map(number => number.id)
        )
        .assocIn(['numbersById'], keyBy(action.payload.data, 'id'))
        .value()

    case 'NUMBERS/GET_NUMBERS_ANALYTICS_PENDING':
      return i.assocIn(state, ['numbersAnalyticsLoading'], true)
    case 'NUMBERS/GET_NUMBERS_ANALYTICS_REJECTED':
      return i.assocIn(state, ['numbersAnalyticsLoading'], false)
    case 'NUMBERS/GET_NUMBERS_ANALYTICS_FULFILLED':
      return i
        .chain(state)
        .assocIn(['numbersAnalytics'], action.payload.data)
        .value()

    case 'NUMBERS/GET_AVAILABLE_NUMBERS_PENDING':
      return i.assocIn(state, ['available', action.meta.cacheKey, 'loading'], true)
    case 'NUMBERS/GET_AVAILABLE_NUMBERS_REJECTED':
      return i.assocIn(state, ['available', action.meta.cacheKey, 'loading'], false)
    case 'NUMBERS/GET_AVAILABLE_NUMBERS_FULFILLED':
      return i
        .chain(state)
        .assocIn(['available', action.meta.cacheKey, 'loading'], false)
        .assocIn(['available', action.meta.cacheKey, 'data'], action.payload.data)
        .value()

    case 'NUMBERS/CREATE_NUMBER_PENDING':
      return i.assoc(state, 'numbersCreateLoading', true)
    case 'NUMBERS/CREATE_NUMBER_REJECTED':
      return i.assoc(state, 'numbersCreateLoading', false)
    case 'NUMBERS/CREATE_NUMBER_FULFILLED':
      analytics.track('Numbers - Create', {
        ...action.payload.data,
        value: action.meta.yearlyValue,
        revenue: action.meta.yearlyValue,
      })

      // create Twilio mobile numbers may return empty service (if regulatory compliance not provided)
      if (!action.payload.data.service) {
        return i.assoc(state, 'numbersCreateLoading', false)
      }

      return i
        .chain(state)
        .updateIn(['numbers'], numbers => i.unshift(numbers, action.payload.data.service.id))
        .assocIn(['numbersById', action.payload.data.service.id], action.payload.data.service)
        .assoc('numbersCreateLoading', false)
        .value()

    case 'NUMBERS/UPDATE_NUMBER_PENDING':
      return i.assoc(state, 'numbersUpdateLoading', true)
    case 'NUMBERS/UPDATE_NUMBER_REJECTED':
      return i.assoc(state, 'numbersUpdateLoading', false)
    case 'NUMBERS/UPDATE_NUMBER_FULFILLED': {
      analytics.track('Numbers - Update', {
        ...action.payload.data,
      })
      return i
        .chain(state)
        .assocIn(['numbersById', action.payload.data.id], action.payload.data)
        .assoc('numbersUpdateLoading', false)
        .value()
    }

    case 'NUMBERS/CHANGE_CALL_PLAN_FULFILLED':
      analytics.track('Numbers - Update Call Plan', action.payload.data)
      return state

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Numbers/Numbers.reducer.js